<template>
  <div class="agreement-container">
    <div class="agreement-header">
      <h1>英才计划用户协议</h1>
    </div>
    <div class="agreement-content">
      <div class="agreement-section">
        <h2>一、协议的接受与修改</h2>
        <p>1.1 欢迎您使用英才计划平台（以下简称"本平台"）提供的服务。本协议是您与本平台之间关于使用本平台服务的法律协议。</p>
        <p>1.2 您在注册或使用本平台服务前，请仔细阅读本协议的全部内容。如果您不同意本协议的任何条款，请立即停止注册或使用本平台服务。</p>
        <p>1.3 本平台有权随时修改本协议的内容，并以网站公告的形式向用户公布。修改后的协议自公布之日起生效。如果您继续使用本平台服务，即视为您已接受修改后的协议。</p>
      </div>
      
      <div class="agreement-section">
        <h2>二、用户注册与账户管理</h2>
        <p>2.1 用户在使用本平台服务前，必须注册一个账户。注册时，用户必须提供真实、准确、完整的个人信息，并在信息变更时及时更新。</p>
        <p>2.2 用户账户的用户名和密码由用户自行设置和保管。用户应对其账户下的所有活动和行为承担法律责任。</p>
        <p>2.3 如发现账户被他人非法使用，用户应立即通知本平台。因用户未及时通知而造成的损失，本平台不承担责任。</p>
      </div>
      
      <div class="agreement-section">
        <h2>三、服务内容与使用规范</h2>
        <p>3.1 本平台提供的服务包括但不限于在线课程、考试模拟、学习资料下载等。</p>
        <p>3.2 用户在使用本平台服务时，必须遵守国家法律法规和本平台的相关规定，不得从事任何违法违规活动。</p>
        <p>3.3 用户不得利用本平台服务侵犯他人的知识产权、隐私权或其他合法权益。</p>
      </div>
      
      <div class="agreement-section">
        <h2>四、知识产权</h2>
        <p>4.1 本平台提供的所有内容，包括但不限于文字、图片、音频、视频、软件等，均受知识产权法律法规的保护。</p>
        <p>4.2 未经本平台书面许可，用户不得复制、转载、传播、修改或使用本平台的任何内容。</p>
      </div>
      
      <div class="agreement-section">
        <h2>五、免责声明</h2>
        <p>5.1 本平台不保证服务的不间断性和无错误性，因网络故障、系统维护等原因导致服务中断或错误的，本平台不承担责任。</p>
        <p>5.2 本平台对用户使用本平台服务所产生的任何直接或间接损失不承担责任。</p>
      </div>
      
      <div class="agreement-section">
        <h2>六、协议的终止</h2>
        <p>6.1 用户可以随时终止使用本平台服务。</p>
        <p>6.2 如用户违反本协议的任何条款，本平台有权立即终止提供服务，并保留追究用户法律责任的权利。</p>
      </div>
      
      <div class="agreement-section">
        <h2>七、法律适用与争议解决</h2>
        <p>7.1 本协议的订立、执行和解释均适用中华人民共和国法律。</p>
        <p>7.2 如双方发生争议，应首先通过友好协商解决；协商不成的，任何一方均可向有管辖权的人民法院提起诉讼。</p>
      </div>
      
      <div class="agreement-section">
        <h2>八、其他条款</h2>
        <p>8.1 本协议构成双方之间的完整协议，取代之前的所有口头或书面协议。</p>
        <p>8.2 如本协议的任何条款被认定为无效或不可执行，其余条款仍应保持有效。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  metaInfo: {
    title: '英才计划用户协议'
  }
}
</script>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.agreement-header {
  text-align: center;
  margin-bottom: 30px;
}

.agreement-header h1 {
  font-size: 28px;
  color: #333;
  font-weight: bold;
}

.agreement-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.agreement-section {
  margin-bottom: 25px;
}

.agreement-section h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.agreement-section p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
  text-indent: 2em;
}
</style>